(function() {
    'use strict';

    angular
        .module('functional7App')
        .controller('ProgramaDetailController', ProgramaDetailController);

    ProgramaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Programa', 'Ejercicio', 'Media'];

    function ProgramaDetailController($scope, $rootScope, $stateParams, previousState, entity, Programa, Ejercicio, Media) {
        var vm = this;

        vm.programa = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('functional7App:programaUpdate', function(event, result) {
            vm.programa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
